import React from "react";
import "./Footer.css"; // assuming you will add styles there

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-overlay">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Contact us</h3>
            <p>+347 55 44-48-55</p>
            <p>info@brandbridge.am</p>
          </div>
          <div className="footer-section">
            <h3>Location</h3>
            <p>Moskovyan 26</p>
            <p>8am - 23pm</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
